<script setup lang="ts">
import StepHeader from '@/components/checkout/StepHeader.vue';
import { ExtendedStep } from '@/components/checkout/Steps.vue';

defineProps<{
  disabled?: boolean;
  hideChangeLink?: boolean;
  step: ExtendedStep;
}>();

const transitionPending = defineModel<boolean>('transitionPending', { required: true });
</script>

<template>
  <div class="px-4 md:px-0">
    <StepHeader
      :class="{ 'mt-5 md:mt-8': step.stepNumber > 1 }"
      :changeLinkTarget="step.route"
      :disabled="!step.enabled || !!disabled"
      :showChangeLink="step.complete && !hideChangeLink"
      :stepNumber="step.stepNumber"
    >
      {{ step.title }}
    </StepHeader>
    <transition
      name="fade"
      mode="out-in"
      @after-enter="transitionPending = false"
      @before-leave="transitionPending = true"
    >
      <slot />
    </transition>
  </div>
</template>
